import { render } from "./PickDesc.vue?vue&type=template&id=663dc536&scoped=true"
const script = {}

import "./PickDesc.vue?vue&type=style&index=0&id=663dc536&scoped=scoped&lang=less"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663dc536"]])

export default __exports__